export function remToPx(value: number): number {
	const { fontSize } = getComputedStyle(document.documentElement);

	return parseFloat(fontSize) * value;
}
